export default {
      id: "author-usage",
      viewBox: "0 0 20 20",
      url: "/assets/" + "icons.svg#author",
      toString: function () {
        return this.url;
      }
    }